import { fetchIPLocation } from '@/services/geographic';

const sceneInfoList = {};

export function createSceneInfo(type, props = {}) {
  sceneInfoList[type] = new SceneInfo(props);
  return sceneInfoList[type];
}

export function getSceneValue(type) {
  return sceneInfoList[type] ? sceneInfoList[type].getValue() : {};
}

export async function initPageScene({ sceneInfo }) {
  sceneInfo.update('environment', {
    manufacturer: 'pc',
    screenResolution: `${window.screen.width} * ${window.screen.height}`,
  });
  const response = await fetchIPLocation();
  const { lat, lng } = response?.geoPoint || {};
  sceneInfo.update('init', {
    initLatitude: lat,
    initLongitude: lng,
    initPositionSource: 0,
    initCoordinateSource: 0,
  });
  sceneInfo.update('common', {
    userLongitude: lng,
    userLatitude: lat,
  });
}

export async function setPageSubmitScene({ sceneInfo }) {
  const response = await fetchIPLocation();
  const { lat, lng } = response?.geoPoint || {};
  sceneInfo.update('page', {
    submitLatitude: lat,
    submitLongitude: lng,
    submitCoordinateSource: 0,
  });
}

export class SceneInfo {
  constructor(props) {
    this.info = this.initSceneInfo();
    LXAnalytics('get', 'msid', msid => {
      this.update('init', {
        sessionId: msid,
      });
    });
  }

  /**
   * 更新场景信息数据
   * @param phase {'common' | 'map' | 'page' | 'init'}
   * @param payload {Record<string, any>}
   */
  update(phase, payload) {
    console.log('[sceneInfo:update]', phase, payload);
    const updatedFieldsSet = new Set(this.info.updatedFields);
    Object.keys(payload || {}).forEach(key => {
      updatedFieldsSet.add(key);
      this.info[phase][key] = payload[key];
    });
    this.info.updatedFields = [...updatedFieldsSet];
  }

  /**
   * 递增场景信息数据
   * @param phase {'common' | 'map' | 'page' | 'init'}
   * @param key {string}
   */
  increment(phase, key) {
    this.update(phase, {
      [key]: this.info[phase][key] + 1,
    });
  }

  /**
   * 用于提交的场景信息数据
   * @returns {any}
   */
  getValue() {
    const { updatedFields, ...sceneInfo } = this.info;
    const sceneInfoExt = {
      ...sceneInfo.init,
      ...sceneInfo.environment,
      ...sceneInfo.page,
      ...sceneInfo.map,
    };
    sceneInfoExt.unsetFields = Object.keys({ ...sceneInfo.common, ...sceneInfoExt }).filter(
      key => !updatedFields.includes(key)
    );
    return {
      ...sceneInfo.common,
      sceneInfoExt,
    };
  }

  initSceneInfo() {
    return {
      updatedFields: [], // 设置过的字段列表，用来计算没获取的字段unsetFields
      // 设备 / 业务相关的信息（与旧场景信息保持兼容）
      common: {
        // 设备相关
        dpId: null,
        wifi: null,
        cx: null,
        // 业务相关
        refineType: null,
        utmSource: null,
        actionPath: null,
        clientType: null,
        version: null,
        // 用户定位
        userLat: null,
        userLng: null,
      },
      init: {
        initLatitude: null,
        initLongitude: null,
        initPositionSource: null, // 定位来源（老）
        initCoordinateSource: null, // 定位来源（新）
        initCoordinateAccuracy: null, // 定位精度
        sessionId: null,
        mtraceId: null,
      },
      environment: {
        manufacturer: null, // 手机品牌
        model: null, // 手机型号
        os: null, // 系统
        screenResolution: null, // 屏幕分辨率
        isRoot: null, // 是否root
        isMulti: null, // 是否双开
      },
      page: {
        enterMap: 0,
        mapEditCnt: 0,
        adUserIpt: 0,
        addressEditCnt: 0,
        cateUserIpt: 0,
        remoteSubmitOption: null,
        remoteSubmitReason: null,
        submitPositionSource: null,
        // 提交时用户经纬度
        submitLatitude: null,
        submitLongitude: null,
        submitCoordinateAccuracy: null, // 提交时用户经纬度精度
        submitCoordinateSource: null, // 提交时用户经纬度定位来源
        cellTowers: null, // 提交时基站列表，knb无法获取
        wifiList: null, // 提交时扫描wifi列表
        gpsLocation: null, // 提交时GPS定位
        beacons: null, // 提交时蓝牙列表
      },
      map: {
        nonLngLat: null,
        zoomMap: 0,
        enlargeMapCnt: 0,
        shrinkMapCnt: 0,
        moveMap: 0,
        moveMapCnt: 0,
        realTimePosition: null,
        enterMapLatitude: null,
        enterMapLongitude: null,
        confirmMapLatitude: null,
        confirmMapLongitude: null,
      },
    };
  }
}
